/**
 * Guarantors List Page
 */
import React from 'react';

const GuarantorsList = () => {
  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Guarantors</h1>
      <p className="text-gray-600 dark:text-gray-400 mt-2">Manage loan guarantors</p>
    </div>
  );
};

export default GuarantorsList;
